import { useState } from "react";
import Review from "./Review";
import Payment from "./Payment/Payment";
import toBoolean from "../../lib/iprs-react-library/src/util/toBoolean";
import finaliseReferralAndBooking from "../App/finaliseBooking";
import { LoadingIndicator } from "../../lib/iprs-react-library/src";
import saveReferral from "../PersonCapture/Referral";

const ReviewAndPay = ({ doUpdate, api, appState }) => {
    const [reviewOrPay, setReviewOrPay] = useState("Review");

    const takePayment = toBoolean(appState?.websiteConfig?.AdditionalData?.IsPaymentCardRequired);

    // flag true when we are processing
    const [loading, setLoading] = useState(false);

    const handleReviewOrPay = value => {
        console.log("ReviewAndPay: handleReviewOrPay", value, takePayment);
        if (value.doCancel) {
            doUpdate({ doCancel: true });
        } else if (
            value?.CardPaymentCheckDone ||
            (value?.reviewOK && (!takePayment || appState?.CardPaymentCheckDone))
        ) {
            console.log("ReviewAndPay: finaliseReferralAndBooking");
            setLoading(true);
            finaliseReferralAndBooking(appState)
                .then(r => {
                    console.log("ReviewAndPay: finaliseReferralAndBooking", r);
                    setLoading(false);
                    doUpdate({
                        allDone: true,
                        CaseRef: r.CaseRef,
                        CaseID: r.CaseID
                    });
                })
                .catch(e => {
                    console.error("ReviewAndPay: error", e);
                    setLoading(false);
                    doUpdate({ error: "Error saving booking" });
                })
                .finally(() => {
                    setLoading(false);
                }
                );
        } else if (value.reviewOK) {

            if (reviewOrPay === "Review") {
                const haveCaseID = appState?.caseID || appState?.websiteConfig?.CaseID;
                if (!haveCaseID) {
                    setLoading(true);
                    saveReferral(api, appState)
                        .then(r => {
                            console.log(
                                "ReviewAndPay: finaliseReferralAndBooking",
                                r
                            );
                            const url = new URL(r.BookingURL);
                            const token = url.searchParams.get("token");
                            const caseID = r.CaseID;
                            const caseRef = r.CaseRef;
                            doUpdate({
                                ReferralComplete: true,
                                CaseID: caseID,
                                CaseRef: caseRef,
                                Token: token
                            });
                            api.setToken(token); // set the token for the API
                            setLoading(false);
                            setReviewOrPay("Pay");
                        })
                        .catch(e => {
                            console.error("ReviewAndPay: error", e);
                            setLoading(false);
                            doUpdate({ error: "Error saving booking" });
                        })
                        .finally(() => {
                            setLoading(false);
                        });
                } else {
                    setReviewOrPay("Pay");
                }
            } else {
                setReviewOrPay("Review");
            }
        } else {
            console.error("ReviewAndPay: unexpected value", value);
            throw new Error("ReviewAndPay: unexpected value");
        }
    };

    return (
        <>
            {reviewOrPay === "Review" ? (
                <Review
                    api={api}
                    doUpdate={handleReviewOrPay}
                    appState={appState}
                    loading={loading}
                />
            ) : (
                <Payment api={api} handleReviewOrPay={handleReviewOrPay} doUpdate={doUpdate} appState={appState} />
            )}
            <LoadingIndicator loading={loading} />
        </>
    );
};

export default ReviewAndPay;
